export default __webpack_public_path__ + "static/vino3-9f8ebe33252e812f4d494238613d7117.jpg";